<template>
    <div v-if="text" class="d-flex align-items-center mt-10">
        <span class="bullet bullet-bar bg-primary align-self-stretch"
              v-bind:class="[bg_class]"
        ></span>
        <label
            class="checkbox checkbox-lg  checkbox-inline flex-shrink-0 m-0 mx-4">
            <input type="checkbox" value="1">
            <span></span>
        </label>
        <div class="d-flex flex-column flex-grow-1">
            <div class="text-capitalize text-dark-75 text-hover-primary font-weight-bold font-size-lg mb-1"
            >{{ text || 'N/A' }}
            </div>
            <span class="text-muted font-weight-bold">{{ $t(label) || 'N/A' }}</span>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'label-text',
        props: {
            text: String,
            label: String,
            bg_class: String,
        }
    }
</script>
